import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import React from 'react'
import { sendParameters } from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'

export default function AdditionalCalculationWidget({ task, isCanceled }) {
  const [needsAdditionalCalculation, setNeedsAdditionalCalculation] =
    React.useState(task.meta?.needsAdditionalCalculation || false)
  const [files, setFiles] = React.useState([])

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      isCanceled={isCanceled}
      label="Финансово-экономический отдел"
      onSave={() =>
        sendParameters(
          task.paidServiceId,
          task.id,
          { needsAdditionalCalculation },
          files
        )
      }
    >
      <FormControlLabel
        control={
          <Checkbox
            disabled={!enabled}
            value={needsAdditionalCalculation}
            checked={needsAdditionalCalculation}
            onChange={(e) => setNeedsAdditionalCalculation(e.target.checked)}
          />
        }
        label="Требуется калькуляция или объем работ отличается от первоначальной калькуляции"
      />

      {needsAdditionalCalculation && (
        <Box display="flex" flexDirection="column">
          <Typography variant="subtitle1" color="black">
            Калькуляция обновленная
          </Typography>
          {enabled ? (
            <FileUpload
              files={files}
              onUpload={(file) => setFiles([...files, file])}
              onDelete={(id) =>
                setFiles(files.filter((file) => file.id === id))
              }
            />
          ) : (
            <FileViewWidget files={task.files} />
          )}
        </Box>
      )}
    </TaskWrapper>
  )
}
